export const toggleSimpleStore = () => {
    return {
        type : 'TOGGLE_SIMPLE_STORE'
    }
}


// WEBPACK FOOTER //
// ./src/pages/Store/actions/storeActions.js